<template>
  <a-card style="width: 100%;margin-bottom: 10px;position: relative">
    <p style="text-align: center;font-weight: bold;font-size: 24px">第{{ customInfo.serialNumber }}集</p>
    <video :ref="'vueRef' + customInfo.id" id="vueRef" :src="customInfo.videoUrl || ''" style="width:100%;height:150px;"
      controls></video>
    <!-- <div v-if="customInfo.videoUrl" style="position: relative; width: 100%; border-radius: 8px">
      <div :data-vjs-player="true">
        <video 
          :id="'videoPlayer_' + customInfo.id" 
          class="video-js vjs-default-skin" 
          controls 
          preload="auto"
          style="width: 100%; height: 300px">
        </video>
      </div>
      <div class="subtitle-overlay" :id="'subtitleOverlay_' + customInfo.id"></div>
    </div> -->

    <a-modal v-model:visible="previewVisible" width="720px" @cancel="handlePreviewClose" :footer="null">
      <div style="text-align: center; font-weight: bold; font-size: 24px; margin-bottom: 10px;">
        第{{ currentEpisodeNumber }}集
      </div>
      <div v-if="showVideo" style="position: relative; width: 100%; border-radius: 8px;">
        <video ref="videoPlayer" class="video-js vjs-default-skin" controls preload="auto"
          style="width: 100%; height: 720px;"></video>
        <div class="subtitle-overlay" ref="subtitleOverlay"></div>
      </div>
    </a-modal>
    <!-- gatherType 下拉框 -->
    <a-select v-model:value="customInfo.gatherType" placeholder="选择类型"
      style="width: 120px; margin-top: 20px; margin-bottom: 20px;" @change="handleGatherTypeChange(customInfo)">
      <a-select-option value="1">彩蛋</a-select-option>
      <a-select-option value="2">花絮</a-select-option>
      <a-select-option value="3">预告片</a-select-option>
    </a-select>
    <a-button v-if="customInfo.videoUrl" type="primary" size="small" class="preview-btn" @click="openPreview(customInfo)">
      预览
    </a-button>

    <p style="margin-top: 10px">中文字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="1" @change="change">
      </gatherUploadBtn>
    </p>
    <p>英文字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="2" @change="change">
      </gatherUploadBtn>
    </p>
    <p>日语字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="3" @change="change">
      </gatherUploadBtn>
    </p>

    <p style="margin-top: 10px">印尼字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="4" @change="change">
      </gatherUploadBtn>
    </p>
    <p>葡语字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="5" @change="change">
      </gatherUploadBtn>
    </p>
    <p>西语字幕:
      <gatherUploadBtn :customInfo="customInfo" :customIndex="customIndex" :customType="6" @change="change">
      </gatherUploadBtn>
    </p>
    <p>
      更新时间:{{ customInfo.updateTime }}
    </p>
    <a-checkbox @change="onChange" :checked="checked" style="position: absolute;right: 5px;top: 5px">
    </a-checkbox>
  </a-card>
</template>

<script>
import { updateGather } from "@/api/video/gather";
import gatherUploadBtn from "./gatherUploadBtn";
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
export default {
  name: "gatherUpload",
  components: {
    gatherUploadBtn
  },
  props: {
    customInfo: {
      type: Object,
    },
    customIndex: {
      type: Number
    },
    checked: {
      type: Boolean
    },
  },
  data() {
    return {
      previewVisible: false,
      showVideo: false,
      previewUrl: '',
      subtitleZhUrl: '',
      subtitleEnUrl: '',
      subtitleJaUrl: '',

      subtitleIdUrl: '',
      subtitlePtUrl: '',
      subtitleEsUrl: '',
      gatherType: '',
      uniqueKey: 0, // 控制 video 销毁和重建
      currentEpisodeNumber: '',
      subtitles: [],
      // selectedLanguage: 'zh', // 默认中文
      allSubtitles: {
        zh: [],
        en: [],
        ja: [],
      },
      subtitleTimer: null,
    }
  },
  mounted() {

  },

  methods: {
    async handleGatherTypeChange(info) {
      try {
        await updateGather({
          id: info.id,
          gatherType: info.gatherType,
          videoId: info.videoId,
          serialNumber: info.serialNumber
        });
        this.$message.success('更新成功');
      } catch (err) {
        console.error(err);
        this.$message.error('更新失败');
      }
    },
    async loadSrt(url) {
      const res = await fetch(url)
      const text = await res.text()
      return this.parseSrt(text)
    },

    parseSrt(srt) {
      const pattern = /\d+\s+(\d{2}:\d{2}:\d{2},\d{3})\s-->\s(\d{2}:\d{2}:\d{2},\d{3})\s+([\s\S]*?)(?=\n\d+\s+\d{2}|\n*$)/g
      const result = []
      let match
      while ((match = pattern.exec(srt)) !== null) {
        result.push({
          start: this.toSeconds(match[1]),
          end: this.toSeconds(match[2]),
          text: match[3].trim().replace(/\n/g, '<br>')
        })
      }
      return result
    },

    toSeconds(timeStr) {
      const [h, m, s] = timeStr.replace(',', '.').split(':')
      return parseFloat(h) * 3600 + parseFloat(m) * 60 + parseFloat(s)
    },

    startSubtitleSync() {
      if (this.subtitleTimer) {
        clearInterval(this.subtitleTimer)
      }

      this.subtitleTimer = setInterval(() => {
        if (!this.player || this.subtitles.length === 0) return

        const currentTime = this.player.currentTime()
        const current = this.subtitles.find(
          s => s.start <= currentTime && s.end >= currentTime
        )
        this.$refs.subtitleOverlay.innerHTML = current ? current.text : ''
      }, 300)
    },

    stopSubtitleSync() {
      if (this.subtitleTimer) {
        clearInterval(this.subtitleTimer)
        this.subtitleTimer = null
      }
    },
    async openPreview(item) {
      this.showVideo = false;
      this.$nextTick(async () => {
        this.previewUrl = item.videoUrl;
        this.currentEpisodeNumber = item.serialNumber

        // 直接从 customInfo 中获取字幕地址
        this.subtitleZhUrl = item.subtitleCn || '';
        this.subtitleEnUrl = item.subtitleEn || '';
        this.subtitleJaUrl = item.subtitleJa || '';

        this.subtitleIdUrl = item.subtitleId || '';
        this.subtitlePtUrl = item.subtitlePt || '';
        this.subtitleEsUrl = item.subtitleEs || '';

        this.showVideo = true;
        this.previewVisible = true;
        await this.$nextTick();
        this.initVideoPlayer();
      });
    },


    async loadAndParseAllSubtitles() {
      if (this.subtitleZhUrl) {
        const zhData = await fetch(this.subtitleZhUrl).then(res => res.text())
        this.zhSubs = this.parseSrt(zhData)
      } else {
        this.zhSubs = []
      }

      if (this.subtitleEnUrl) {
        const enData = await fetch(this.subtitleEnUrl).then(res => res.text())
        this.enSubs = this.parseSrt(enData)
      } else {
        this.enSubs = []
      }

      if (this.subtitleJaUrl) {
        const jaData = await fetch(this.subtitleJaUrl).then(res => res.text())
        this.jaSubs = this.parseSrt(jaData)
      } else {
        this.jaSubs = []
      }


      if (this.subtitleIdUrl) {
        const idData = await fetch(this.subtitleIdUrl).then(res => res.text())
        this.idSubs = this.parseSrt(idData)
        console.log("111111111111111111111" + this.idSubs)
      } else {
        this.idSubs = []
      }

      if (this.subtitlePtUrl) {
        const ptData = await fetch(this.subtitlePtUrl).then(res => res.text())
        this.ptSubs = this.parseSrt(ptData)
        console.log("111111111111111111111" + this.ptSubs)
      } else {
        this.ptSubs = []
      }

      if (this.subtitleEsUrl) {
        const esData = await fetch(this.subtitleEsUrl).then(res => res.text())
        this.esSubs = this.parseSrt(esData)
        console.log("111111111111111111111" + this.esSubs)
      } else {
        this.esSubs = []
      }
    },

    initVideoPlayer() {
      if (this.player) {
        this.player.dispose()
        this.player = null
      }

      this.player = videojs(this.$refs.videoPlayer, {
        autoplay: true,
        controls: true,
        preload: 'auto',
        sources: [{ src: this.previewUrl, type: 'video/mp4' }]
      });

      // 关闭自带字幕显示
      this.player.ready(() => {
        const tracks = this.player.textTracks()
        for (let i = 0; i < tracks.length; i++) {
          tracks[i].mode = 'disabled'
        }
      })

      // 先等待字幕加载完毕再绑定事件
      this.loadAndParseAllSubtitles().then(() => {
        this.player.on('timeupdate', () => {
          if (!this.zhSubs || !this.enSubs || !this.jaSubs || !this.idSubs || !this.ptSubs || !this.esSubs) return
          const currentTime = this.player.currentTime()
          const zhText = this.getSubtitleTextAtTime(this.zhSubs, currentTime)
          const enText = this.getSubtitleTextAtTime(this.enSubs, currentTime)
          const jaText = this.getSubtitleTextAtTime(this.jaSubs, currentTime)

          const idText = this.getSubtitleTextAtTime(this.idSubs, currentTime)
          const ptText = this.getSubtitleTextAtTime(this.ptSubs, currentTime)
          const esText = this.getSubtitleTextAtTime(this.esSubs, currentTime)

          this.$refs.subtitleOverlay.innerHTML = [zhText, enText, jaText, idText, ptText, esText].filter(Boolean).join('<br>')
        })
      })
    },

    getSubtitleTextAtTime(subs, time) {
      if (!subs || subs.length === 0) return ''
      for (const sub of subs) {
        if (time >= sub.start && time <= sub.end) return sub.text
      }
      return ''
    },
    handlePreviewClose() {
      this.previewVisible = false
      this.showVideo = false
      this.stopSubtitleSync()
      if (this.player) {
        this.player.pause()
        this.player.dispose()
        this.player = null
      }
    },
    getBaseName(filename) {
      if (!filename || typeof filename !== 'string') {
        return ''
      }
      // 先取第一个 '.' 之前的部分
      const nameWithoutExt = filename.split('.')[0]
      // 如果包含 '-'，取 '-' 分割后的第2部分，否则就直接返回
      if (nameWithoutExt.includes('-')) {
        const parts = nameWithoutExt.split('-')
        return parts[1] || nameWithoutExt  // 防止只有一个 '-'，取不到索引1时返回原始
      }
      return nameWithoutExt
    },


    beforeDestroy() {
      this.stopSubtitleSync()
      if (this.player) {
        this.player.dispose()
        this.player = null
      }
    },

    change() {
      this.$emit("change")
    },
    onChange(e) {
      console.log(e.target.checked);
      this.$emit("selectOption", {
        checked: e.target.checked,
        id: this.customInfo.id,
        data: this.customInfo
      })
    }
  }
}
</script>

<style scoped>
.subtitle-overlay {
  position: absolute;
  bottom: 40px;
  width: 100%;
  text-align: center;
  color: white;
  font-size: 16px;
  text-shadow: 0 0 5px black;
  pointer-events: none;
  z-index: 10;
}

::v-deep(.ant-modal-close) {
  top: -16px !important;
  /* 往上拉一点 */
  right: -16px !important;
  /* 往右拉一点 */
  z-index: 999;

  padding: 6px;
}

::v-deep(.ant-modal-close-x) {
  color: black !important;
  font-size: 18px;
}

.preview-btn {
  min-width: 200px;
  /* 按钮更长一点 */
  border-radius: 20px;
  /* 圆角按钮 */
  font-weight: bold;
  color: #fff;
  /* 白字 */
  background-color: #1890ff;
  /* 蓝底 */
  border-color: #1890ff;
}

.preview-btn:hover {
  background-color: #40a9ff;
  border-color: #40a9ff;
  color: #fff;
}
</style>